import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FORM_COMP_MODES } from '@services/constants.service';
import { ErrorService } from '@services/error.service';
import { LegacyNameService } from '@services/legacy-name.service';

@Component({
  selector: 'app-name-form-legacy',
  templateUrl: './name-form-legacy.component.html',
  styleUrls: ['./name-form-legacy.component.scss'],
  standalone: false
})
export class NameFormLegacyComponent implements OnInit {
  @Input() firstName: string | undefined = '';
  @Input() lastName: string | undefined = '';
  @Input() username: string | undefined = '';
  @Input() mode: string | undefined;

  @Output() exitFormEvent = new EventEmitter<boolean>();

  public nameForm: FormGroup;
  public loading: boolean = false;
  public error: string = '';

  // necessary to reference it in the html template
  public readonly FORM_COMP_MODES = FORM_COMP_MODES;

  constructor(
    private formBuilder: FormBuilder,
    private errorService: ErrorService,
    private legacyNameService: LegacyNameService,
    // private userService: UserService
  ) {
    this.nameForm = this.formBuilder.group({
      firstname: ['', {
        validators: [Validators.required],
      }],
      lastname: ['', {
        validators: [Validators.required]
      }]
    });
  }

  ngOnInit(): void {
    if (this.firstName) {
      this.nameForm.controls['firstname'].setValue(this.firstName);
    }
    if (this.lastName) {
      this.nameForm.controls['lastname'].setValue(this.lastName);
    }
  }

  public onSubmit(event: any): void {
    this.loading = true;
    if (this.nameForm.status == "VALID") {
      this.legacyNameService.updateName(this.nameForm.controls['firstname'].value, this.nameForm.controls['lastname'].value, this.username).then(() => {
        this.loading = false;
        this.exitFormEvent.emit(true);
      }).catch((err) => {
        this.loading = false;
        this.error = 'Fehler beim Signup';
        this.errorService.printError(err);
      });
    }
  }

}
